import * as fromDatatype from '../datatype-library/index';

export interface app_principal_provider_app_link_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  login_subject: fromDatatype.VarcharDatatypeInterface;
  login_principal: fromDatatype.VarcharDatatypeInterface;
  provider_hdr: fromDatatype.VarcharDatatypeInterface;
  provider_app_hdr: fromDatatype.NumericDatatypeInterface;
  provider_app_line: fromDatatype.NumericDatatypeInterface;
  provider_app_ext: fromDatatype.NumericDatatypeInterface;
  link_type: fromDatatype.NumericDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_principal_provider_app_link_hdr_RowClass implements app_principal_provider_app_link_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  login_subject: fromDatatype.VarcharDatatypeInterface;
  login_principal: fromDatatype.VarcharDatatypeInterface;
  provider_hdr: fromDatatype.VarcharDatatypeInterface;
  provider_app_hdr: fromDatatype.NumericDatatypeInterface;
  provider_app_line: fromDatatype.NumericDatatypeInterface;
  provider_app_ext: fromDatatype.NumericDatatypeInterface;
  link_type: fromDatatype.NumericDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


